import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgPreviousAlt = function SvgPreviousAlt(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M12 0C5.39 0 0 5.344 0 11.953c0 6.61 5.39 12 12 12s12-5.39 12-12S18.61 0 12 0zm0 21.984c-5.531 0-9.984-4.5-9.984-9.984 0-5.531 4.5-9.984 9.984-9.984 5.531 0 9.984 4.5 9.984 9.984S17.531 21.984 12 21.984z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M18 10.969H8.437l2.297-2.297a1.02 1.02 0 000-1.406 1.02 1.02 0 00-1.406 0L5.344 11.25a1.02 1.02 0 000 1.406l3.984 3.985c.188.187.469.28.703.28.235 0 .516-.093.703-.28a1.02 1.02 0 000-1.407l-2.296-2.296H18a.99.99 0 00.984-.985c0-.515-.468-.984-.984-.984z"
  }));
};

export default SvgPreviousAlt;